"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  width: 1em;\n  height: 1em;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CircleIcon = void 0;

var react_1 = __importDefault(require("react"));

var styledTypes_1 = require("./styledTypes");

function CircleIcon(_ref) {
  var color = _ref.color,
      iconColor = _ref.iconColor,
      children = _ref.children;
  var theme = react_1["default"].useContext(styledTypes_1.ThemeContext);
  return react_1["default"].createElement(Container, {
    style: {
      background: color ? theme[color] : 'currentColor'
    }
  }, react_1["default"].cloneElement(children, {
    width: '0.8em',
    height: '0.8em',
    color: iconColor ? theme[iconColor] : 'white'
  }));
}

exports.CircleIcon = CircleIcon;
var Container = styledTypes_1.styled.div(_templateObject());